const pageNameKey = "gatewayMachinesListHeader";

export const gatewayMachinesListHeaderEn = {
  [pageNameKey]: {
    statusAndMachineName: "Status - Machine Name",
    machineId: "Machine ID",
    dsnAddress: "DSN Address",
    statusAndGatewayName: "Status - Gateway Name",
  },
};

export const gatewayMachinesListHeaderPtBr = {
  [pageNameKey]: {
    statusAndMachineName: "Status - Nome da máquina",
    machineId: "ID de máquina",
    dsnAddress: "Endereço DSN",
    statusAndGatewayName: "Status - Nome do gateway",
  },
};

export const gatewayMachinesListHeaderDe = {
  [pageNameKey]: {
    statusAndMachineName: "Status - Maschinenname",
    machineId: "Maschinen-ID",
    dsnAddress: "DSN Adresse",
    statusAndGatewayName: "Status - Gateway-Name",
  },
};

export const gatewayMachinesListHeaderZhHans = {
  [pageNameKey]: {
    statusAndMachineName: "状态 - 机器名称",
    machineId: "机器ID",
    dsnAddress: "DSN 地址",
    statusAndGatewayName: "状态 - 网关名称",
  },
};

export const gatewayMachinesListHeaderIt = {
  [pageNameKey]: {
    statusAndMachineName: "Stato - Nome della macchina",
    machineId: "ID macchina",
    dsnAddress: "Indirizzo DSN",
    statusAndGatewayName: "Stato - Nome gateway",
  },
};

export const gatewayMachinesListHeaderEs = {
  [pageNameKey]: {
    statusAndMachineName: "Estado - Nombre de la máquina",
    machineId: "ID de máquina",
    dsnAddress: "Dirección DSN",
    statusAndGatewayName: "Estado - Nombre del gateway",
  },
};

export const gatewayMachinesListHeaderNl = {
  [pageNameKey]: {
    dsnAddress: "DSN-adres",
    machineId: "Machine-ID",
    statusAndGatewayName: "Status - Gatewaynaam",
    statusAndMachineName: "Status - Machinenaam",
  },
};

export const gatewayMachinesListHeaderTr = {
  [pageNameKey]: {
    dsnAddress: "DSN Adresi",
    machineId: "Makine Kimliği",
    statusAndGatewayName: "Durum - Ağ Geçidi Adı",
    statusAndMachineName: "Durum - Makine Adı",
  },
};
